import React from 'react';

import { FaBrain, FaCamera, FaChartLine, FaClipboardList, FaLightbulb, FaUtensils } from 'react-icons/fa';

import { StyledAIShowcase } from './styles';
import { CardTitle, Heading2, Paragraph1, SectionTitle } from '../../../theme';
import { bemClassName } from '../../../utils/bem';

const b = bemClassName('ai-showcase');

const AI_FEATURES = [
  {
    icon: FaCamera,
    title: 'AI Food Scanner',
    description: 'Snap a photo of any meal and get instant calorie and macro breakdown. No manual logging required.',
  },
  {
    icon: FaClipboardList,
    title: 'AI Personalized Plans',
    description:
      'Get a tailored nutrition plan with daily macro targets, meal timing, hydration goals, and activity recommendations, all generated by AI based on your profile.',
  },
  {
    icon: FaUtensils,
    title: '5,000+ Recipes',
    description:
      'Browse and log meals from a library of over 5,000 recipes, filtered to match your dietary preferences and nutritional goals.',
  },
  {
    icon: FaChartLine,
    title: 'Trend Analysis',
    description:
      'AI detects patterns in your weight trends, nutrition habits, and activity consistency, then explains what they mean.',
  },
  {
    icon: FaBrain,
    title: 'Plateau Detection',
    description:
      'When progress stalls, Active Shape detects it and regenerates your plan with updated recommendations to help you break through.',
  },
  {
    icon: FaLightbulb,
    title: 'Daily AI Insights',
    description:
      'Receive personalized daily insights that explain your progress, highlight achievements, and guide your next steps.',
  },
];

const AIShowcase = () => {
  return (
    <StyledAIShowcase>
      <div className={b()}>
        <div className={b('header')}>
          <Heading2>POWERED BY AI</Heading2>
          <SectionTitle>Beyond Tracking. Real Understanding.</SectionTitle>
          <div className={b('header-description')}>
            <Paragraph1>
              Most fitness apps track data. Active Shape explains it. Our AI analyzes your nutrition, workouts, and
              habits to provide insights that actually help you progress.
            </Paragraph1>
          </div>
        </div>

        <div className={b('features')}>
          {AI_FEATURES.map((feature) => {
            const Icon = feature.icon;
            return (
              <div key={feature.title} className={b('feature')}>
                <div className={b('feature-icon')}>
                  <Icon />
                </div>
                <div className={b('feature-title')}>
                  <CardTitle>{feature.title}</CardTitle>
                </div>
                <div className={b('feature-description')}>
                  <Paragraph1>{feature.description}</Paragraph1>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </StyledAIShowcase>
  );
};

export default AIShowcase;
